import React from "react";
import CommingSoonImage from '../../../assest/images/UnderConstruction-Illustration.svg';

export default class CommingSoon extends React.PureComponent {


    render(): React.ReactNode {
        return (<>
            <div className="coming-soon-area">
                <div className="col-12">
                    <img src={CommingSoonImage} width="230" height="124" alt="this page will be created soon" />
                </div>
                <div className="col-12">
                    <label className="title">فعلا در دسترس نیست</label>
                </div>
                <div className="col-12">
                    <label className="subtitle">
                        این بخش به زودی به اپلیکیشن افزوده خواهد شد
                    </label>
                </div>
            </div>
        </>);
    }
}